import {
  ConfigFormItem,
  IWidgetComponentProps,
  RichTextAdvancedRender,
  currencyNumberFormatter,
  getWidgetProps,
  useNumberExpressionValue,
} from '@framework/engine';
import { ComputedStaticTextInput } from '@framework/form';
import React, { useCallback } from 'react';
import { IBurdenWidget } from './IBurdenWidget';

export interface IBurdenWidgetComponentProps
  extends IWidgetComponentProps<IBurdenWidget> {}

export function BurdenWidgetComponent(props: IBurdenWidgetComponentProps) {
  const { widget } = props;

  const options = getWidgetProps(props);

  const value = useNumberExpressionValue(options.name, widget.expression);

  const formatValue = useCallback(
    (value: number | null) =>
      value != null ? currencyNumberFormatter.format(value) : '',
    [],
  );

  return (
    <ConfigFormItem
      hidden={widget.layout?.hide}
      name={options.name}
      label={<RichTextAdvancedRender inline text={options.label} />}
      help={<RichTextAdvancedRender inline text={options?.helpText} />}
      layout={{ hideVisualLabel: options.hideLabel }}
      readonly={options.readonly}
    >
      <ComputedStaticTextInput
        name={options.name}
        value={value}
        removeBorder={widget.layout?.removeBorder}
        format={formatValue}
        readonly={options.readonly}
      />
    </ConfigFormItem>
  );
}
